export var InformativeCardVariantType;
(function (InformativeCardVariantType) {
    InformativeCardVariantType["REGULAR"] = "REGULAR";
    InformativeCardVariantType["URGENT"] = "URGENT";
    InformativeCardVariantType["NEUTRAL_INFO"] = "NEUTRAL_INFO";
    InformativeCardVariantType["NEUTRAL_SUCCESS"] = "NEUTRAL_SUCCESS";
})(InformativeCardVariantType || (InformativeCardVariantType = {}));
//# sourceMappingURL=informativeCard.js.map